import { gql } from '__generated__';

export default gql(`
  mutation SortParticipantFields($input: SortParticipantFieldsInput!) {
    sortParticipantFields(input: $input) {
      id
      position
    }
  }
`);
